import util from '../util'

let controller = 'IntegracaoParceiro'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
  doTest: function (dto) {
    return util.Axios.Post(controller + '/ValidarConexao', dto)
  },
  desbloquearTreasury: function (dto) {
    return util.Axios.Post(controller + '/AtualizaStatusTreasury/1', dto)
  },
  postEtapas: function (dto, etapa) {
    return util.Axios.Post(controller + '/' + etapa, dto)
  },
  obterPmas: function () {
    return util.Axios.Get(controller + '/ObterPmas')
  },
  gerarQRCodeEstatico: function (identificadorPma) {
    return util.Axios.Post(controller + `/GerarQRCodeEstatico/${identificadorPma}`)
  }
})
